<template>
    <div>

        <h1 style="font-size: 24px; color: black;">视频列表</h1>
        <div style="margin-bottom: 10px;">
            <el-card class="form-container" style="margin-top: 25px">
                <el-row type="flex" align="middle">
                    <el-col :span="5">
                        <span> 游戏名称：</span>
                        <el-select v-model="query.gameName" filterable placeholder="请选择/输入" gameName="gameName">
                            <el-option
                                v-for="item in gameList"
                                :key="item.id"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="queryVideos">查询</el-button>
                        <el-upload :action="upload()" :headers="headers"
                                   :on-success="handleZipSuccess"
                                   :before-upload="beforeZipUpload"
                                   :show-file-list="false"
                                   v-loading.fullscreen.lock="loading"
                                   ref="upload">
                            <el-button class="margin-left-10" type="success">批量新增</el-button>
                        </el-upload>
                        <el-button class="margin-left-10" type="success" @click="editDialogFun(true,'新增视频')">新增
                        </el-button>
                    </el-col>
                </el-row>
            </el-card>
        </div>

        <div>
            <el-table border :data="videos">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="gameName" label="游戏名称"></el-table-column>
                <el-table-column label="视频缩略图">
                    <template slot-scope="scope">
                        <template v-if="scope.row.imagePath">
                            <img :src="VUE_APP_CDN_URL+scope.row.imagePath" width="70px" height="100px" alt=""/>
                        </template>
                        <template v-if="scope.row.imageSize">
                            {{ (scope.row.imageSize / 1000).toFixed(2) }}kb
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="视频">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showVideo(scope.row)">查看视频</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="视频名称"></el-table-column>
                <el-table-column prop="dtCreate" label="上传时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="gameId" label="游戏id"></el-table-column>
                <el-table-column prop="id" label="视频id"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="editDialogFun(true,'编辑视频',scope.row)">
                            编辑
                        </el-button>
                        <br>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row)"
                                   v-if="!scope.row.discoverSelectorId">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>

        <el-dialog :title="editDialog.title" center :visible.sync="editDialog.show" width="30%" :data="video">
            <table>
                <tr>
                    <td><span>游戏名称：</span></td>
                    <td colspan="2">
                        <el-select v-model="video.gameName" filterable placeholder="请选择/输入" gameName="gameName">
                            <el-option
                                v-for="item in gameList"
                                :key="item.id"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td><span>视频缩略图：</span></td>
                    <td>
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleImageSuccess"
                                   :before-upload="beforeImageUpload">
                            <img v-if="video.imagePath" :src="VUE_APP_CDN_URL+video.imagePath" class="avatar" alt=""/>
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                        <template v-if="video.imageSize">
                            {{ (video.imageSize / 1000).toFixed(2) }}kb
                        </template>
                    </td>
                    <td><span>缩略图支持.png 或.jpg 格式，且不超过500kb</span></td>
                </tr>
                <tr>
                    <td><span>视频：</span></td>
                    <td>
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleVideoSuccess"
                                   :before-upload="beforeVideoUpload">
                            <video v-if="video.videoPath" :src="VUE_APP_CDN_URL+video.videoPath" class="avatar1"
                                   controls="controls"/>
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                        <template v-if="video.videoSize">
                            {{ (video.videoSize / 1000 / 1000).toFixed(2) }}mb
                        </template>
                    </td>
                    <td><span>视频支持.mp4 格式，且不超过5m</span></td>
                </tr>
                <tr>
                    <td style="text-align-last: center;" colspan="3">
                        <el-button plain size="mini" type="success" @click="saveOrUpdateVideo">确定</el-button>
                        <el-button plain size="mini" type="danger" @click="editDialogFun(false)">返回</el-button>
                    </td>
                </tr>
            </table>

        </el-dialog>

        <el-dialog :title="messageDialog.title" center :visible.sync="messageDialog.show" width="30%">
            <h1 v-html="messageDialog.message"/>
            <el-button plain size="mini" type="success" @click="messageDialogFun(false)">确定</el-button>
        </el-dialog>

        <el-dialog title="视频详情"
                   center
                   :visible.sync="videoDialogVisible"
                   @open="videoInfo"
                   @close="videorDialogVisible=false"
                   width="320px">
            <div>
                <video :src="VUE_APP_CDN_URL+videoInfo().videoPath" style="width: 270px; height: 480px" class="avatar1"
                       controls="controls"/>
                <h1>视频大小：{{ (videoInfo().videoSize / 1000 / 1000).toFixed(2) }}MB</h1>
            </div>
        </el-dialog>

    </div>

</template>

<script>

import {formatDate, gameSimpleList, queryVideos, removeVideo, saveOrUpdateVideo} from "@/http/api";

export default {
    inject: ['reload'],
    name: "VideoList",
    data() {
        return {
            loading: false,
            editDialog: {
                show: false,
                title: null
            },
            VUE_APP_BASE_URL: null,
            VUE_APP_CDN_URL: null,
            uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
            data: {},
            video: {
                id: null,
                name: null,
                videoPath: null,
                imagePath: null,
                gameId: null,
                gameName: null,
                imageSize: null,
                videoSize: null
            },
            videoDialogVisible: false,
            videos: null,
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            query: {
                gameName: null,
                size: null,
                page: null
            },
            headers: {},
            messageDialog: {
                show: false,
                title: null,
                message: null
            },
            gameList: []
        }
    },
    methods: {
        formatDate(row, column) {
            return formatDate(row, column);
        },
        queryVideos() {
            this.query.page = this.page.page;
            this.query.size = this.page.size;
            queryVideos(this.query).then(resp => {
                this.videos = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
                this.headers = {Authorization: this.$store.state.user.token};
                gameSimpleList().then(resp => {
                    this.gameList = resp.data.info;
                });
            });
        },
        saveOrUpdateVideo() {
            if (this.video.gameName == null) {
                this.$message.error('游戏名不存在!');
                return;
            }
            if (this.video.imagePath == null) {
                this.$message.error('图片不存在!');
                return;
            }
            if (this.video.videoPath == null) {
                this.video.videoPath = "";
                // this.$message.error('视频不存在!');
                this.video.name = "";
                return;
            }
            saveOrUpdateVideo(this.video).then(resp => {
                if (resp.data.status === 0) {
                    this.editDialogFun(false);
                    this.queryVideos();
                }
            });
        },
        remove(data) {
            this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeVideo(data).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryVideos();
                    }
                });
            }).catch(() => {
            })
        },
        handleImageSuccess(data) {
            this.video.imagePath = data.info;
        },
        handleZipSuccess(data) {
            this.loading = false;
            let title;
            if (data.status === 0) {
                title = "温馨提示";
            } else {
                title = "错误提示";
            }
            this.messageDialogFun(true, title, data.msg);
            this.queryVideos();
        },
        handleVideoSuccess(data) {
            this.video.videoPath = data.info;
        },
        beforeImageUpload(data) {
            const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
            const size = data.size < 1024 * 500;
            if (!type) {
                this.$message.error('上传图片只能是png,jgp格式!');
            }
            if (!size) {
                this.$message.error('上传图片大小不能超过500kb!');
            }
            this.video.imageSize = data.size;
            return type && size;
        },
        beforeVideoUpload(data) {
            const type = data.name.substring(data.name.lastIndexOf('.')) === '.mp4';
            const size = data.size < 1024 * 1024 * 20;
            if (!type) {
                this.$message.error('上传视频只能是mp4格式!');
            }
            if (!size) {
                this.$message.error('上传视频大小不能超过20m!');
            }
            if (type || size) {
                this.video.name = data.name;
            }
            this.video.videoSize = data.size;
            return type && size;
        },
        beforeZipUpload(data) {
            const type = data.name.substring(data.name.lastIndexOf('.')) === '.zip';
            const size = data.size < 1024 * 1024 * 100;
            if (!type) {
                this.$message.error('上传zip只能是zip格式!');
            }
            if (!size) {
                this.$message.error('上传zip大小不能超过100m!');
            }
            let b = type && size;
            if (b) {
                this.loading = true;
                this.messageDialogFun(true, '温馨提示', '上传中，请稍候');
            }
            return type && size;
        },
        upload() {
            return this.VUE_APP_BASE_URL + 'video/upload';
        },
        showVideo: function (data) {
            this.videoDialogVisible = true;
            this.data = data;

        },
        videoInfo: function () {
            return this.data;
        },
        editDialogFun(show, title, data) {
            this.editDialog.show = show;
            this.editDialog.title = title;

            this.video.id = null;
            this.video.gameName = null;
            this.video.videoPath = null;
            this.video.imagePath = null;
            this.video.name = null;
            this.video.videoSize = null;
            this.video.imageSize = null;
            if (show && data) {
                this.video.id = data.id;
                this.video.gameName = data.gameName;
                this.video.videoPath = data.videoPath;
                this.video.imagePath = data.imagePath;
                this.video.name = data.name;
                this.video.videoSize = data.videoSize;
                this.video.imageSize = data.imageSize;
            }

        },
        messageDialogFun(show, title, message) {
            this.messageDialog.show = show;
            this.messageDialog.title = title;
            this.messageDialog.message = message;
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryVideos();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryVideos();
        },
    },
    created() {
        this.queryVideos();
    },
    mounted() {
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }
}
</script>

<style lang="less">
.sub {
    position: relative;
    left: 570px
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 60px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 60px;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar1 {
    width: 150px;
    height: 200px;
    display: block;
}

.elalert {
    max-width: 89%;
    left: 11%;
}

.iconSize {
    font-size: 14px;
    font-weight: normal;
}

</style>
